import { formatNameWithAlias, 
         formatName, 
         formatPhone, 
         formatDateTime, 
         formatAddress, 
         meterToMile, 
         secondToMinute,
         delimiter,
         formatSpeed,
         firstWordToUpperCase } from '@/utils'

import { GENDERS, 
         MUST_BE_METS, 
         TAG_STATUS, 
         RELATIONSHIP, 
         ROUTE_ACCESS, 
         CICO_SCOPE, 
         CICO_LOCATION, 
         INSPECTION,
         OPEN_STATUS, 
         ENABLE_STATUS, 
         VISIBLE_STATUS, 
         EMERGENCY_STATUS, 
         TRIP_STATUS, 
         TRIGGER_TYPE, 
         PICKUP, 
         DROPOFF, 
         TRIP_STATUS_ENDED, 
         CICO_TYPES, 
         PUBLISH_STATUS, 
         SIGNATURE_REQUIRED,
         YES_OR_NO,
         RGC_STATUS, 
         FOLLOW_STATUS,
         COMMON_STATUS,
         LOST_CARD_STATUS,
         SCHEDULED_TYPE,
         ACTION_TYPE, 
         SKIP_REQUEST_STATUSES,
         SKIP_REQUEST_BY,
         SPECIAL_NEED,
         BUS_TYPES,
    } from '@/utils/config'

import moment from 'moment'

function formatTime(time) {
    if(!time || time == null) return ''

    if(/^\d{2}:\d{2}:\d{2}$/.test(time)) {
        return moment(time, 'HH:mm:ss').format('hh:mm A')
    }else if(/^\d{2}:\d{2}$/.test(time)) {
        return moment(time, 'HH:mm').format('hh:mm A')
    }else {
        return moment(time)._isValid ? moment(time).format('hh:mm A') : time
    }
}

export default {
    filterPhone(value, calling_code) {
        return value ? formatPhone(calling_code, value) : '-'
    },
    filterDatetime(value, format, originFormat) {
        return value ? formatDateTime(value, format, originFormat) : '-'
    },
    scheduledTime(from, to) {
        if(from || to) {
            const start = formatTime(from) || '-' //  moment(from, 'HH:mm:ss').format('hh:mm A')
            const end = formatTime(to) || '-' // moment(to, 'HH:mm:ss').format('hh:mm A')
            return start + ' ~ ' + end
        }else {
            return '-'
        }
    },
    tripTime(row, status) {
        const departure = row.actual_departure_datetime || row.manual_start_datetime
        const arrival = row.actual_arrival_datetime || row.manual_end_datetime || row.force_end_datetime

        if(status == TRIP_STATUS_ENDED) {
            return formatTime(departure) + ' ~ ' + formatTime(arrival)
        }else {
            return formatTime(departure) + ' ~ ' + (formatTime(arrival) || 'present')
        }
    },
    tripDuration(row) {
        const departure = row.actual_departure_datetime || row.manual_start_datetime
        const arrival = row.actual_arrival_datetime || row.manual_end_datetime || row.force_end_datetime

        if(departure && arrival) {
            const diffSecond = moment(arrival).diff(moment(departure), 'second')
            return diffSecond > 0 ? (secondToMinute(diffSecond) + ' mins') : diffSecond
        }else {
            return '-'
        }
    },
    duration(duration) {
        if(duration !== null && duration !== '') {
            if(duration == 0) return 0

            const isNegative = duration < 0
            duration = Math.abs(duration)
            
            const hours = Math.floor(duration / 3600)
            const mins = Math.floor((duration % 3600) / 60)
            const seconds = duration - hours*3600 - mins*60
            const result = (hours > 0 ? (hours + 'h ') : '' ) + (mins > 0 ? (mins + 'm ') : '' ) + (seconds > 0 ? (seconds + 's') : '' )
            return isNegative ? '-' + result : result
        }else {
            return '-'
        }
    },
    formatTime(time) {
        return formatTime(time) || '-'
    },
    formatDate(date, format="MM/DD/YYYY") {
        if(!date || date == null) return '-'
        const _moment = moment(date, 'YYYY-MM-DD')
        return _moment._isValid ? _moment.format(format) : date
    },
    secondToTime(s) {
        let zeroize = (value, length) => {
            if (!length) {  
                length = 2;  
            }  
            value = new String(value); 
            let zeros = ''; 
            for (let i = 0; i < (length - value.length); i++) {  
                zeros += '0';  
            }  
            return zeros + value;  
        };
        const hour = Math.floor(s / 60 / 60);
        const minute = Math.floor((s - 60*60*hour)/60);
        const second = s - hour*60*60 - minute*60;
        return (hour == 0 ? '' : zeroize(hour) + ':') + zeroize(minute) + ':' + zeroize(second);
    },
    filterAlias(value, alias) {
        return formatNameWithAlias(value, alias)
    },
    filterName(value, name2, name3) {
        return formatName(value, name2, name3) || '-'
    },
    filterLoginMethod(type) {
        // 1: RFID, 2: NFC, 3: QRCode, 4: BarCode, 5: Driver Identity, 6: Token
        if(!type) return '-'
        const mapping = {
            '1': 'RFID',
            '2': 'NFC',
            '3': 'QRCode',
            '4': 'BarCode',
            '5': 'Driver Identity',
            '6': 'Token',
        }
        return mapping[type]
    },
    filterLoginType(type) {
        // 1: Sign in, 2: Sign out
        if(!type) return '-'
        const mapping = {
            '1': 'Sign in',
            '2': 'Sign out',
        }
        return mapping[type]
    },
    batteryStatus(status) {
        if(!status) {return '-';}
        let text = 'UNKNOWN';
        switch (status) {
            case '2':
                text = 'CHARGING';
                break;
            case '3':
                text = 'DISCHARGING';
                break;
            case '4':
                text = 'NOT_CHARGING';
                break;
            case '5':
                text = 'FULL';
                break;
            default:
                text = 'UNKNOWN';
                break;
        }
        return text;
    },
    temperature(temperature) {
        return temperature ? Math.round(( (temperature*9/5+32) * 100)/100) + '°F' : '-'
    },
    nextworkType(type) {
        // 1: WIFI, 2: Cellular
        if(!type) return '-'
        const mapping = {
            '1': 'WIFI',
            '2': 'Cellular',
        }
        return mapping[type]
    },
    address(addr) {
        return formatAddress(addr) || '-'
    },
    formatGender(gender, field="alias") {
        const item = GENDERS.find(el => el.value == gender)
        return item ? item[field] : 'Unknown'
    },
    formatMustBeMets(value) {
        const item = MUST_BE_METS.find(el => el.value == value)
        return item ? item.label : '-'
    },
    formatSpecialNeed(value) {
        const item = SPECIAL_NEED.find(el => el.value == value)
        return item ? item.label : '-'
    },
    formatTagStatus(value) {
        const item = TAG_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },
    formatRelationship(value) {
        const item = RELATIONSHIP.find(el => el.value == value)
        return item ? item.label : '-'
    },
    repeatOn(from, to) {
        return moment(from).format('MM/DD/YYYY') + ' ~ ' + moment(to).format('MM/DD/YYYY')
    },
    repeatOnWeekdays(repeat_on_weekdays) {
        let repeat_on_weekdays_array = repeat_on_weekdays ? repeat_on_weekdays.split('') : []
        const mapping = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        repeat_on_weekdays_array = repeat_on_weekdays_array.map((letter,index) => {
            if(letter == '-') {
                return ''
            }else {
                return mapping[index]
            }
        })
        return repeat_on_weekdays_array.filter(el => el).join(' ')
    },
    lockedStatus(status) {
        // 1: Normal, 2: Locked
        if(!status) return '-'
        const mapping = {
            '1': 'Normal',
            '2': 'Locked',
        }
        return mapping[status]
    },

    enabled(value) {
        const item = ENABLE_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    visibility(value) {
        const item = VISIBLE_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    open(value) {
        const item = OPEN_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    routeAccess(value) {
        // 1: Device Scope, 2: Driver Scope, 3: Transporter Scope
        const item = ROUTE_ACCESS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    cicoScope(value) {
        const item = CICO_SCOPE.find(el => el.value == value)
        return item ? item.label : '-'
    },

    cicoLocation(value) {
        const item = CICO_LOCATION.find(el => el.value == value)
        return item ? item.label : '-'
    },
    inspection(value) {
        const item = INSPECTION.find(el => el.value == value)
        return item ? item.label : '-'
    },
    emengencyStatus(value) {
        const item = EMERGENCY_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },
    tripStatus(value) {
        const item = TRIP_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },
    meterToMile(meter, zeroWithUnit=false) {
        if(meter!= null && meter >= 0) {
            const mile = meterToMile(meter)
            return mile + (mile > 0 ? ' mi' : (zeroWithUnit ? 'mi' : ''))
        }else {
            return '-'
        }
    },
    secondToMinute(sencond, zeroWithUnit=false) {
        if(sencond!= null && sencond >= 0) {
            const mins = secondToMinute(sencond)
            return mins + (mins > 0 ? ' mins' : (zeroWithUnit ? 'mins' : ''))
        }else {
            return '-'
        }
    },

    triggerType(value) {
        const item = TRIGGER_TYPE.find(el => el.value == value)
        return item ? item.label : '-'
    },

    cardType(value) {
        return CICO_TYPES[value] || '-'
    },

    pickupType(value) {
        return value == PICKUP ? 'Pick Up' : (value == DROPOFF ? 'Drop Off' : '-')
    },

    scheduledType(value) {
        const item = SCHEDULED_TYPE.find(el => el.value == value)
        return item ? item.label : '-'
    },
    
    actionType(value) {
        const item = ACTION_TYPE.find(el => el.value == value)
        return item ? item.label : '-'
    },

    publishStatus(value) {
        const item = PUBLISH_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    signatureRequired(value) {
        const item = SIGNATURE_REQUIRED.find(el => el.value == value)
        return item ? item.label : '-'
    },

    yesOrNo(value) {
        const item = YES_OR_NO.find(el => el.value == value)
        return item ? item.label : '-'
    },
    delimiter(value, blocks, delimiterSign) {
        return value ? delimiter(value, blocks, delimiterSign) : '-'
    },

    RGCStatus(value) {
        const item = RGC_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    followStatus(value) {
        const item = FOLLOW_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    status(value) {
        const item = COMMON_STATUS[value]
        return item ? firstWordToUpperCase(item) : '-'
    },

    lostCardStatus(value) {
        const item = LOST_CARD_STATUS.find(el => el.value == value)
        return item ? item.label : '-'
    },

    formatActorType(value) {
        if(!value) return '-'
        const mapping = {
            '1': 'Driver',
            '2': 'District User',
            '3': 'Super Admin',
        }
        return mapping[value]
    },

    speed(val) {
        return val ? formatSpeed(val) : '-'
    },

    skipRequestStatus(value) {
        const item = SKIP_REQUEST_STATUSES.find(el => el.value == value)
        return item ? item.label : '-'
    },
    skipRequestBy(value) {
        const item = SKIP_REQUEST_BY.find(el => el.value == value)
        return item ? item.label : '-'
    },
    busType(value) {
        const item = BUS_TYPES.find(el => el.value == value)
        return item ? item.label : '-'
    },
}